module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-list-container",
    attrs: {
      "id": "list-container-template"
    }
  }, [_c('div', {
    staticClass: "total-count"
  }, [_vm._v("총 "), _c('span', [_vm._v(_vm._s(_vm.totalCnt))]), _vm._v("건")]), _vm._v(" "), (_vm.totalCnt === 0) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("검색된 강좌가 없습니다.")]) : _c('div', {
    staticClass: "job-card-grid new-type moreType"
  }, _vm._l((_vm.displayedList), function(item, index) {
    return _c('edu-card', {
      key: index,
      attrs: {
        "education": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "button-area btn-load-more"
  }, [(_vm.list.length < _vm.totalCnt) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.more
    }
  }, [_c('i', {
    staticClass: "ico ico-plus"
  }), _vm._v("\n      더보기\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ff3685"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/components/EduCardListMoreType.vue
// module id = 1454
// module chunks = 6